import { BaseService } from '@partful/shared/api/baseService';
import { ConfigurationGetResponse } from '../model/types';

export class ConfigurationsService extends BaseService {
  async get(account: string, configurationPID: string): Promise<ConfigurationGetResponse> {
    const params = new URLSearchParams({
      account,
    });

    const res = await this.client.get<ConfigurationGetResponse>(
      `/configurations/${configurationPID}?${params.toString()}`
    );
    return res.data;
  }
}
